import React from 'react';

import { GridComponent, Inject, ColumnsDirective, ColumnDirective, Search, Page } from '@syncfusion/ej2-react-grids';
import { Header } from '../components';
import { BACKEND_URL } from '../data/constants';

class Pagos extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
        items: [],
        DataisLoaded: false
    };
  }

  componentDidMount() {
    fetch(`${BACKEND_URL}/stripe/payments`, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    })
    .then((res) => res.json())
    .then((json) => {
        this.setState({
            items: json,
            DataisLoaded: true
        });
    })
  }

  render() {
    const { DataisLoaded, items } = this.state;
    if (!DataisLoaded) return (
      <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white">
        <h1 className='text-center'> Trayendo pagos.... </h1> 
      </div> 
    );

    return (
      <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl">
        <Header category="Page" title="Pagos Stripe" />

        <GridComponent
          dataSource={items}
          width="auto"
          allowPaging
          allowSorting
          pageSettings={{ pageCount: 5 }}
          editSettings={{ allowDeleting: false, allowEditing: false, selection: false }}
          toolbar= {['Search']}
        >
          <ColumnsDirective>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            {paymentsGrid.map((item, index) => <ColumnDirective key={index} {...item} />)}
          </ColumnsDirective>
          <Inject services={[Search, Page]} />

        </GridComponent>
      </div>
    );
  }
}

const paymentsGrid = [
  { field: 'date',
    headerText: 'Fecha',
    width: '200',
    textAlign: 'Center',
  },
  { field: 'currency',
    headerText: 'Moneda',
    width: '100',
    textAlign: 'Center',
  },
  { field: 'amount',
    headerText: 'Cantidad',
    width: '150',
    textAlign: 'Center',
  },
  { field: 'name',
    headerText: 'Nombre',
    width: '400',
    textAlign: 'Center',
  },
  { field: 'email',
    headerText: 'E-Mail',
    width: '400',
    textAlign: 'Center',
  },
];

export default Pagos;